import { useTranslation } from '@axo/shared/i18n';
import { ButtonSet } from '@axo/ui-core/components/Button';
import { FormProvider, useForm } from 'react-hook-form';
import { Form } from '../../../../../components/Form';
import { Navigation } from '../../../../../components/Navigation';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import useInitiatedTracking from '../../../../../hooks/tracking/useInitiatedTracking';
import { Step4Data } from '../../FormData.se.types';
import { EmploymentFormGroup } from '../shared/EmploymentFormGroup';

const touchedFieldsOverride = ['LoanApplication/EmploymentStatus'];

export const Step4 = () => {
  const { t } = useTranslation();

  const { onChange, onSubmit, onPrevStep } = useAxoFormContext<Step4Data>();

  const form = useForm({
    shouldUnregister: true,
    mode: 'onBlur',
  });

  const {
    formState: { isSubmitting, touchedFields },
  } = form;

  useInitiatedTracking({
    shouldTriggerOnInitiated: Object.keys(touchedFields).length > 0,
  });

  return (
    <FormProvider {...form}>
      <Form
        onSubmit={onSubmit}
        onChange={onChange}
        /* We need to override the touched attribute for this for it to trigger a change immediately when it is interacted with.
         Otherwise, the user would need to interact with another field before the change is triggered.*/
        touchedFieldsOverride={touchedFieldsOverride}
      >
        <EmploymentFormGroup />

        <ButtonSet justify={'space-between'} responsive>
          <Navigation.Back onClick={onPrevStep}>{t('back')}</Navigation.Back>
          <Navigation.Continue loading={isSubmitting}>
            {t('continue')}
          </Navigation.Continue>
        </ButtonSet>
      </Form>
    </FormProvider>
  );
};
